import './ClientResourcesListComponent.scss';
import ListInfoCardComponent from "../../../shared/components/list-info-card/ListInfoCardComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import CardComponent from "../../../shared/components/card/CardComponent";
import {CommonService} from "../../../shared/services";

interface ClientResourcesListProps {

}

const listData = [
    {
        title: 'Notice of Privacy Practices',
        link: CommonService._routeConfig.ClientResource()
    },
    {
        title: 'Attendance/Cancellation Policy',
        link: CommonService._routeConfig.ClientResource()
    },
    {
        title: 'Waiver and Release of Liability',
        link: CommonService._routeConfig.ClientResource()
    },
    {
        title: 'Authorization to Release Protected Health Information',
        link: CommonService._routeConfig.ClientResource()
    },
    {
        title: 'Authorization to Disclose Protected Health Information',
        link: CommonService._routeConfig.ClientResource()
    }
]

const ClientResourcesListComponent = (props: ClientResourcesListProps) => {
    return (
        <div className="client-resources-list-component">
            <CardComponent>
                <div className={'client-resources-list-header'}>
                    <div className={'client-resources-list-header-title'}>Client Resources</div>
                    <LinkComponent route={CommonService._routeConfig.ClientResource()}>Show More</LinkComponent>
                </div>
                <div className={'client-resources-list-container'}>
                    {
                        listData.map((item: any, index: number) => {
                            return (
                                <div key={index} className="mrg-bottom-10">
                                    <ListInfoCardComponent backgroundColor={'#F2FAFF'} value={item.title}
                                                           action={<LinkComponent route={item.link}>
                                                               View
                                                           </LinkComponent>}/>
                                </div>
                            )

                        })
                    }
                </div>
            </CardComponent>
        </div>
    )
}
export default ClientResourcesListComponent;

